import { initVueRouter } from './initVueRouter';
import { initHttpAuth } from './initHttpAuth';

export function initMixin (App) {
  App.prototype._init = function (options = {}) {
    initVueRouter(this, options);
    initHttpAuth(this, options);
  };
}
